/**
 * Header-schema URLs keyed by website layout + photo presentation layout.
 *
 * Split out from `useHeaderPhotoPresentationData.constants.ts` so consumers that only need the URL
 * strings (e.g. the website design payload tool) don't pull in the 17 heavy `schemaDefaults/*`
 * template modules. This is the single source of truth for the URLs — the sibling constants file
 * pairs each URL with its default `template` object.
 */
export const SCHEMA_URL_BY_WEBSITE_LAYOUT: Record<string, Record<string, string>> = {
  aloha: {
    center: 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',
    photoSlider: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
  },
  brannan: {
    monogram: 'https://withjoy.com/assets/public/websiteHeaderSchemas/monogram-v1_1_1.json',
    center: 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',
    fullWidth: 'https://withjoy.com/assets/public/websiteHeaderSchemas/fullWidth-v1_1_1.json',
    pageWidth: 'https://withjoy.com/assets/public/websiteHeaderSchemas/pageWidth-v1_1_1.json',
    photoSlider: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
    photoTrio: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrio-v1_1_1.json',
    photoTrioPageWidth: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrioPageWidth-v1_1_1.json',
    noPhoto: 'https://withjoy.com/assets/public/websiteHeaderSchemas/noPhoto-v1_1_1.json',
    photoArch: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoArch-v1_1_1.json',
    photoDuoLeft: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoLeft-v1_1_1.json',
    photoDuoRight: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoRight-v1_1_1.json',
    photoMarquee: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoMarquee-v1_1_1.json',
    photoBackground: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackground-v1_1_3.json',
    photoBackgroundMonogram: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackgroundMonogram-v1_0_1.json',
    videoBackground: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackground-v1_1_1.json',
    videoBackgroundMonogram: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackgroundMonogram-v1_0_0.json',
    videoArch: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoArch-v1_1_1.json',
  },
};
